var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsIconProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Profile",
    "data-name": "Controls/icon/Profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2861",
    "data-name": "Group 2861",
    transform: "translate(-11 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    width: 38,
    height: 38,
    transform: "translate(11 11)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2860",
    "data-name": "Group 2860",
    transform: "translate(-0.332 -0.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M30.332,12.332a18,18,0,1,0,18,18A18.02,18.02,0,0,0,30.332,12.332ZM42.032,40.4c-1.706-4.482-8.106-6.474-8.106-6.474a9.307,9.307,0,0,1-3.594.936,9.308,9.308,0,0,1-3.6-.936s-6.4,1.993-8.106,6.473a15.453,15.453,0,1,1,23.4,0Z",
    fill: "#75787b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_600",
    "data-name": "Ellipse 600",
    cx: 6.784,
    cy: 7.757,
    rx: 6.784,
    ry: 7.757,
    transform: "translate(23.548 18.026)",
    fill: "#75787b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsIconProfile);
export default __webpack_public_path__ + "static/media/Controls-icon-Profile.890cd068ba919a3e9d447f8a7c746b6b.svg";
export { ForwardRef as ReactComponent };